export class MaterialModel {
    _id: string;
    name: string;
    description: string;
    rStabName: string;
    eModule: number;
    gModule: number;
    fu: number;
    ni: number;
    density: number;

    constructor(id = null,
        name = '',
        description = '',
        rStabName = null,
        eModule = null,
        gModule = null,
        fu = null,
        ni = null,
        density = null) {
            this._id = id;
            this.name = name;
            this.description = description;
            this.rStabName = rStabName;
            this.eModule = eModule;
            this.gModule = gModule;
            this.fu = fu;
            this.ni = ni;
            this.density = density;
    }
}
